// extracted by mini-css-extract-plugin
module.exports = {"lia-flex-grid":"WidgetTagsFilter_lia-flex-grid__EBOgD","lia-filter-prefix-text":"WidgetTagsFilter_lia-filter-prefix-text__Axqvn"};